<div class="field field-textarea">
  @if (label) {
    <span class="label">{{label}}</span>
  }
  <textarea
    [class.error-field]="error"
    [(ngModel)]="model"
    (input)="modelChange.emit($event.target.value)"
    (keyup.enter)="enter.emit()"
    [rows]="rows"
    [placeholder]="placeholder"
  ></textarea>
  @if (afterString) {
    <span class="after-textarea passive-gray">{{afterString | display}}</span>
  }
  @if (error) {
    <span class="error-field-display">{{error}}</span>
  }
</div>